import { computed, ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import Vue from 'vue';
import store from '@/store';

const SERVICE_TYPE_LABEL = {
  verifi: 'Visa',
  ethoca: 'Mastercard',
};

const METRIC_ROWS = [
  {
    key: 'orders',
    label: 'Orders',
    subValues: [{ get: m => m.orders }],
  },
  {
    key: 'notifications',
    label: 'Notifications',
    subValues: [
      { label: 'New', get: m => m.notifications.new },
      { label: 'Delete', get: m => m.notifications.delete },
    ],
  },
];

const EMPTY_METRICS = { orders: 0, notifications: { new: 0, delete: 0 } };

export default function usePreventReports() {
  const loading = ref(false);
  const months = ref([]);
  const rows = ref([]);
  const expandedItems = ref([]);

  const currentMonth = dayjs().format('YYYY-MM');

  const monthHeaders = computed(() =>
    months.value.map((month, index) => ({
      value: month,
      text: index === 0 || month === currentMonth
        ? 'Current Month'
        : dayjs(month).format('MMMM YYYY'),
    })),
  );

  const merchantItems = computed(() => rows.value);

  function integrationLabel(integration) {
    const label = SERVICE_TYPE_LABEL[integration.serviceType] || integration.serviceType;
    return `── ${label} #${integration.id} ──`;
  }

  function subValue(metricsByMonth, month, sub) {
    const monthMetrics = (metricsByMonth && metricsByMonth[month]) || EMPTY_METRICS;
    return sub.get(monthMetrics) ?? 0;
  }

  function fetchReport() {
    loading.value = true;
    store
      .dispatch('chargebackPreventionReport/fetchReport')
      .then(response => {
        months.value = response.data.months || [];
        rows.value = response.data.rows || [];
      })
      .catch(() => {
        Vue.notify({
          type: 'error',
          title: 'Reports',
          text: 'Cannot fetch prevention monthly activity report',
        });
      })
      .finally(() => {
        loading.value = false;
      });
  }

  fetchReport();

  return {
    loading,
    months,
    rows,
    monthHeaders,
    merchantItems,
    metricRows: METRIC_ROWS,
    expandedItems,
    integrationLabel,
    subValue,
    fetchReport,
  };
}
